import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { createWorkType, updateWorkType } from '../../services/api';
import { toast } from 'sonner';

const today = () => new Date().toISOString().split('T')[0];

export const WorkTypeDialog = ({ open, onOpenChange, workType, units, onSaved }) => {
  const [form, setForm] = useState({ label: '', unit: 'ha', rate: '', valid_from: today() });
  const [saving, setSaving] = useState(false);
  const editing = Boolean(workType);

  useEffect(() => {
    if (open) setForm({ label: workType?.label || '', unit: workType?.unit || 'ha', rate: '', valid_from: today() });
  }, [open, workType]);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.label.trim()) { toast.error('Ievadiet nosaukumu'); return; }
    setSaving(true);
    try {
      if (editing) {
        await updateWorkType(workType.key, { label: form.label.trim(), unit: form.unit });
        toast.success('Darba veids atjaunināts');
      } else {
        await createWorkType({ label: form.label.trim(), unit: form.unit, rate: Number(form.rate || 0), valid_from: `${form.valid_from}T00:00:00` });
        toast.success('Darba veids pievienots');
      }
      onSaved();
      onOpenChange(false);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Neizdevās saglabāt');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="work-type-dialog">
        <DialogHeader>
          <DialogTitle>{editing ? 'Labot darba veidu' : 'Jauns darba veids'}</DialogTitle>
          <DialogDescription>{editing ? 'Nosaukuma vai mērvienības maiņa neietekmē jau aprēķinātās algas.' : 'Norādiet nosaukumu, mērvienību un standarta likmi.'}</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1">
            <Label>Nosaukums</Label>
            <Input value={form.label} onChange={(e) => setForm((p) => ({ ...p, label: e.target.value }))} placeholder="piem. Stigošana" data-testid="work-type-label" />
          </div>
          <div className="space-y-1">
            <Label>Mērvienība</Label>
            <Select value={form.unit} onValueChange={(v) => setForm((p) => ({ ...p, unit: v }))}>
              <SelectTrigger data-testid="work-type-unit"><SelectValue /></SelectTrigger>
              <SelectContent>{units.map((u) => <SelectItem key={u} value={u} data-testid={`work-type-unit-${u}`}>{u}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          {!editing && (
            <div className="grid grid-cols-2 gap-3">
              <div className="space-y-1">
                <Label>Standarta likme (€ / {form.unit})</Label>
                <Input type="number" step="0.01" min="0" value={form.rate} onChange={(e) => setForm((p) => ({ ...p, rate: e.target.value }))} data-testid="work-type-rate" />
              </div>
              <div className="space-y-1">
                <Label>Spēkā no</Label>
                <Input type="date" value={form.valid_from} onChange={(e) => setForm((p) => ({ ...p, valid_from: e.target.value }))} data-testid="work-type-valid-from" />
              </div>
            </div>
          )}
          <div className="flex justify-end gap-2">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} data-testid="work-type-cancel">Atcelt</Button>
            <Button type="submit" disabled={saving} className="bg-[#1F3D2B] hover:bg-[#2a5039]" data-testid="work-type-save">Saglabāt</Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
